import {BaseEntityParams} from "./base-entity-params";

export class EntityWithClubRelationParams extends BaseEntityParams {
    clubId?: number
}
